
export default {
  name: 'UrlsDeRedirecionamento',
  mounted () {
    this.$store.dispatch('sincronizador/pegarUrlsDeRedirecionamento')
  },
  computed: {
    urlsDeRedirecionamento () {
      const dados = this.$store.state.sincronizador.urlsDeRedirecionamento
      return dados
    }
  },
  methods: {
    getImagePath (logo: string) {
      return require(`../../../../static/images/${logo}`)
    },
  }
}
